import { LHCOverruleReasons } from '../enums/LHCOverruleReasons';

/**
 * Check if the LHC reason does NOT require Certified Age Entry. The following LHC reasons are exempt from CAE: ADF, IMM, OSE
 * @param {string} reason - The LHC reason
 * @returns {boolean} - `true` if the LHC reason does NOT requires CAE, `false` otherwise
 */
const isLhcReasonExemptFromCae = (reason) => {
  return [LHCOverruleReasons.EX_ADF, LHCOverruleReasons.MIGRANT, LHCOverruleReasons.CITIZEN].includes(reason);
};

/**
 * This util function cleans up the LHC object by removing the CAE if the LHC reason is exempt from CAE.
 * @param {Object} lhcObject The LHC object for a person
 * @param {string} [keyName='overruledReason'] The key name to check for the LHC reason
 * @returns {Object} The cleaned up LHC object
 */
const removeCaeForCertainLhcReasons = (lhcObject, keyName = 'overruledReason') => {
  if (isLhcReasonExemptFromCae(lhcObject[keyName])) {
    const { cae, ...cleanedLhcObject } = lhcObject;
    return cleanedLhcObject;
  }
  return lhcObject;
};

export { removeCaeForCertainLhcReasons, isLhcReasonExemptFromCae };
